export const analyticsEvent = {
  SHOP_TESTS_FBI_ORDERCTA: 'tap_shop_tests_FBI_orderCTA',
  SHOP_TESTS_GI_ORDERCTA: 'tap_shop_tests_GI_orderCTA',
  SHOP_TESTS_OHI_ORDERCTA: 'tap_shop_tests_OHI_orderCTA',


  SHOP_MYFORMULAS_PRICE_TAG_INFO: 'tap_shop_myformulas_pricetag',
  SHOP_MYFORMULAS_CUSTOMIZE_BUTTON: 'tap_shop_myformulas_customize',
  SHOP_MYFORMULAS_SUPPLEMENTS: 'tap_shop_myformulas_supplements',
  SHOP_MYFORMULAS_GUTFORMULA: 'tap_shop_myformulas_gutformula',
  SHOP_MYFORMULAS_ORALLOZENGES: 'tap_shop_myformulas_orallozenges',
  SHOP_MYFORMULAS_TOOTHPASTEANDGEL: 'tap_shop_myformulas_toothpasteandgel',
  SHOP_MYFORMULAS_CONTINUETOORDERCTA: 'tap_shop_myformulas_ContinuetoOrderCTA',
  SHOP_MYFORMULAS_CUSTOMIZE_CONTINUETOORDERCTA: 'tap_shop_myformulas_customize_continuetoordercta',
  SHOP_MYFORMULAS_CUSTOMIZE_SELECTALL: 'tap_shop_myformulas_customize_selectall',
  SHOP_PRODUCTDETAILS_TAB_SUPPLEMENTS:
    'tap_shop_productdetails_tab_supplements',
  SHOP_PRODUCTDETAILS_TAB_GUTFORMULA: 'tap_shop_productdetails_tab_gutformula',
  SHOP_PRODUCTDETAILS_TAB_ORALLOZENGES:
    'tap_shop_productdetails_tab_orallozenges',
  SHOP_PRODUCTDETAILS_TAB_TOOTHPASTEANDGEL:
    'tap_shop_productdetails_tab_toothpasteandgel',


  SHOP_PRODUCTDETAILS_SUPPLEMENTS_MYINGREDIENTS:
    'tap_shop__productdetails_supplements_myingredients',
  SHOP_PRODUCTDETAILS_SUPPLEMENTS_MYFORMULABENEFITS:
    'tap_shop_productdetails_supplements_myformulabenefits',
  SHOP_PRODUCTDETAILS_SUPPLEMENTS_BUILDMYPLANCTA:
    'tap_shop_productdetails_supplements_buildmyplancta',
  SHOP_PRODUCTDETAILS_SUPPLEMENTS_CONTINUETOORDERCTA:
    'tap_shop_productdetails_supplements_continuetoordercta',
  SHOP_PRODUCTDETAILS_GUTFORMULA_MYINGREDIENTS:
    'tap_shop__productdetails_gutformula_myingredients',
  SHOP_PRODUCTDETAILS_GUTFORMULA_MYFORMULABENEFITS:
    'tap_shop_productdetails_gutformula_myformulabenefits',
  SHOP_PRODUCTDETAILS_GUTFORMULA_BUILDMYPLANCTA:
    'tap_shop_productdetails_gutformula_buildmyplancta',
  SHOP_PRODUCTDETAILS_ORALLOZENGES_MYINGREDIENTS:
    'tap_shop__productdetails_orallozenges_myingredients',
  SHOP_PRODUCTDETAILS_ORALLOZENGES_MYFORMULABENEFITS:
    'tap_shop_productdetails_orallozenges_myformulabenefits',
  SHOP_PRODUCTDETAILS_ORALLOZENGES_BUILDMYPLANCTA:
    'tap_shop_productdetails_orallozenges_buildmyplancta',
  SHOP_PRODUCTDETAILS_TOOTHPASTEANDGEL_MYINGREDIENTS:
    'tap_shop__productdetails_toothpasteandgel_myingredients',
  SHOP_PRODUCTDETAILS_TOOTHPASTEANDGEL_BUILDMYPLANCTA:
    'tap_shop_productdetails_toothpasteandgel_buildmyplancta',
  SHOP_PRODUCTDETAILS_TOOTHPASTEANDGEL_MYFORMULABENEFITS:
    'tap_shop_productdetails_toothpasteandgel_myformulabenefits',
}